import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icon } from '../../../atoms'
import { Button } from '../../../atoms'

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.colors.background.secondary};
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.spacing.huge};
  text-align: center;
`

const IconWrapper = styled.div`
  color: ${({ theme }) => theme.colors.danger};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: ${({ theme }) => theme.colors.danger}20;
  border-radius: ${({ theme }) => theme.borderRadius.circle};
`

const ErrorTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

const ErrorMessage = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  max-width: 500px;
`

export interface PDFErrorStateProps {
  error: Error
  onRetry?: () => void
}

export const PDFErrorState: React.FC<PDFErrorStateProps> = ({
  error,
  onRetry,
}) => {
  const { t } = useTranslation('ui')

  return (
    <ErrorContainer>
      <IconWrapper>
        <Icon name="alert-circle" size="large" />
      </IconWrapper>
      <ErrorTitle>{t('pdfViewer.errors.loadFailed')}</ErrorTitle>
      <ErrorMessage>
        {error.message || t('pdfViewer.errors.defaultMessage')}
      </ErrorMessage>
      {onRetry && (
        <Button onClick={onRetry} variant="primary">
          {t('pdfViewer.errors.tryAgain')}
        </Button>
      )}
    </ErrorContainer>
  )
}
